import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import KpiPlatformUsageChart from "./kpicharts/KpiPlatformUsage";
import { exportMultipleChartsToPdf, generateExcel } from "../../../../utils/pdf";
import { EXLDownloadIcon, PDFDownloadIcon } from "../../../../SvgIconsData";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import ProPopup from "../../../layouts/ProPopup";
import { CrownIcon, SpinnerIcon } from "../../../../assets/icons/iconshere";

const KpiCard = ({ kpi }) => {
  return (
    <div className="col-lg-4 pb-3">
      <div className="card  ">
        <div className="card-body custom-chart ">
          <KpiPlatformUsageChart kpi={kpi} />
        </div>
      </div>
    </div>
  );
};

const KpiReport = ({ list, loading }) => {
  const userData = useSelector((state) => state.userSlice);
  const [userPlan, setUserPlan] = useState(null);
  const [openPro, setOpenPro] = useState(false);

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  const tableData1 = [["KPI Report", ""]];
  const tableData2 = [];

  const loadBox = 4;
  const tileCards = [];

  for (let i = 0; i < loadBox; i++) {
      tileCards.push(
        <div className="col-md-4 pb-3">
        <div className="card  ">
          <div className="card-body custom-chart ">
          <div id="chart">
       <div className="row">
        <div className="col-md-6 d-flex align-itmes-center justify-content-start">
          <h6><Skeleton width="5vw"/></h6></div>
        <div className="col-md-6 d-flex align-itmes-center justify-content-end">
        <Skeleton width="5vw"/>
          </div>
        </div> 
        <Skeleton width="100%" height=" 30vh "/>
      </div>
          </div>
        </div>
      </div> )
  }

  const [pdfSpinner, setPdfSpinner] = useState(false);

  const handleClickPdfDownload = async(name, table1, table2) => {
    setPdfSpinner(true);
    await exportMultipleChartsToPdf(name, table1, table2)
    setPdfSpinner(false);
  }

  return (
    <>
      <div className="row pt-5">
        <div className="col-12 d-flex align-items-center justify-content-end">
          
          {( userPlan && userPlan?.kpi?.download ) ?
            <button className="DefaultRedBtn download px-2" title="Download PDF"
              onClick={() => handleClickPdfDownload("KPI", tableData1, tableData2)}>
              {pdfSpinner ? <SpinnerIcon /> : <PDFDownloadIcon />}
            </button> 
            :
            <button className="DefaultRedBtn pro mb-2" onClick={() => setOpenPro(true)} >
            <CrownIcon  />                                
            <p> Download Reports </p>
            </button>
          }

        </div>
      </div>

      {loading ?
          <div className="row pt-2 ps-2"> {tileCards} </div>
        :
      <div className="row pt-2 ps-2">
        {list.map((item, index) => {
          return <KpiCard key={index} kpi={item} />;
        })}
      </div> 
       }

  <ProPopup openPro={openPro} setOpenPro={setOpenPro} />

    </>
  );
};

export default KpiReport;
